import script from "./DashBoardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashBoardView.vue?vue&type=script&setup=true&lang=ts"

import "./DashBoardView.vue?vue&type=style&index=0&id=2168eaac&lang=css"

const __exports__ = script;

export default __exports__